import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Sticky from '../../Shared/Sticky'

function isActive(tabSlug) {
  if (location.pathname.includes(tabSlug)) {
    return 'is-active'
  } if (tabSlug == 'home' && location.pathname == '/digital-art-competition') {
    return 'is-active'
  }
  return ''
}

function NavigationMenu({ competitionSlug }) {
  return (
    <div>
      <Sticky className="navigation-menu--competition" offset={60} stickyOffset={60}>
        <div className="container-fixed">
          <ul className="nav-tabs nav-tabs--small nav-tabs--navigation-menu">
            <li className={isActive('home')}>
              <Link to={`/${competitionSlug}`}>Home</Link>
            </li>
            <li className={isActive('rules')}>
              <Link to={`/${competitionSlug}/rules`}>Rules</Link>
            </li>
            <li className={isActive('categories-and-prizes')}>
              <Link to={`/${competitionSlug}/categories-and-prizes`}>Categories & Prizes</Link>
            </li>
            <li className={isActive('partners')}>
              <Link to={`/${competitionSlug}/partners`}>Partners</Link>
            </li>
            <li className={isActive('judges')}>
              <Link to={`/${competitionSlug}/judges`}>Judges</Link>
            </li>
            <li className={isActive('gallery')}>
              <Link to={`/${competitionSlug}/gallery`}>Gallery</Link>
            </li>
          </ul>
        </div>
      </Sticky>
    </div>
  )
}

NavigationMenu.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default NavigationMenu
